import React from 'react'
import PropTypes from 'prop-types'
import { Button, Form, Grid, Header } from 'semantic-ui-react'
import WidgetDefinition, { Widget } from './Widget'
import Portlet, { PortletHeader } from './Portlet'
import { chunk } from './Utils'
import css from './WidgetForm.css'
import { translate } from 'react-i18next'

const { arrayOf, instanceOf, func } = PropTypes

let isSelected = (arr) => type => (arr.includes(type))

const availableWidgets = (widgetTypes, fields) => chunk(widgetTypes, 5).map((widgets, j) => {
  let groups = widgets.map(fields)
  return (
    <Form.Group widths='5' key={j}>
      {groups}
    </Form.Group>
  )
})

const availableWidgetsSections = (widgetTypes, fields, header, key) => {
  return (
    <Grid.Column key={key}>
      {
        header
          ? <Header key={key - 1}>
            {header}
          </Header>
          : null
      }
      <Grid
        doubling
        stackable
        columns={Math.ceil(widgetTypes.length / 5)}
        key={key + 1}
      >
        {
          widgetTypes.map(fields)
        }
      </Grid>
    </Grid.Column>
  )
}

class SelectionChange {
  constructor (added, removed) {
    this.added = added
    this.removed = removed || []
  }
}

class WidgetForm extends React.PureComponent {
  static propTypes = {
    widgetTypes: arrayOf(instanceOf(WidgetDefinition)),
    currentWidgets: arrayOf(instanceOf(Widget)),
    onSelectionChange: func.isRequired
  }

  static defaultProps = {
    widgetTypes: [],
    currentWidgets: []
  }

  constructor (props) {
    super(props)
    this.removeAll = this.removeAll.bind(this)
    this.selectAllNew = this.selectAllNew.bind(this)
    this.onSelectionChange = this.props.onSelectionChange
    this.currentSelection = () => this.props.currentWidgets.map(w => w.definition)
    this.currentSelectionNames = () => this.currentSelection().map(d => d.name)
  }

  isSelected (type) {
    return this.currentSelectionNames().includes(type.name)
  }

  newElements () {
    const notAlreadySelected = w => !this.currentSelection().some(c => w.equals(c))
    return this.props.widgetTypes.filter(notAlreadySelected)
  }

  removeAll () {
    this.onSelectionChange(new SelectionChange([], this.currentSelection()))
  }

  select (type) {
    if (this.isSelected(type)) return
    this.onSelectionChange(new SelectionChange([type], []))
  }

  selectAllNew () {
    this.onSelectionChange(new SelectionChange(this.newElements(), []))
  }

  deSelect (type) {
    this.onSelectionChange(new SelectionChange([], [type]))
  }

  render () {
    const { t } = this.props
    let { widgetTypes, widgetSections } = this.props
    let fields = (w, i) => {
      const selected = this.isSelected(w)
      const clickFn = selected ? () => this.deSelect(w) : () => this.select(w)
      let key = PortletHeader.LocalizeHeaderKey(w.name)
      return widgetSections ? (
        <Grid.Column
          key={i - 1}
          style={{
            paddingTop: '0.5rem',
            paddingBottom: '0.5rem'
          }}
        >
          <Form.Checkbox
            key={i}
            label={t(key)}
            onChange={clickFn}
            checked={selected}
          />
        </Grid.Column>
      )
        : (
          <Form.Checkbox
            key={i}
            label={t(key)}
            onChange={clickFn}
            checked={selected}
          />
        )
    }
    return (<Portlet header={t('availableWidgets')}>
      <Form className={css.WidgetForm}>
        {
          widgetSections
            ? <Grid
              doubling
              stackable
              columns={widgetSections.length}
              style={{
                paddingBottom: '1.5rem'
              }}
            >
              {
                widgetSections.map((obj, key) => (
                  availableWidgetsSections(obj.widgets, fields, obj.name, key)
                ))
              }
            </Grid>
            : availableWidgets(widgetTypes, fields)
        }
        <Button basic onClick={this.removeAll}>{t('deselectAll')}</Button>
        <Button basic onClick={this.selectAllNew}>{t('selectAllNew')}</Button>
      </Form>
    </Portlet>)
  }
}

export default translate()(WidgetForm)
export { WidgetForm, SelectionChange, isSelected }
